import { Table } from "react-bootstrap";
import styled from "styled-components";

const TablePrimary = styled(Table)<{ background?: boolean }>`
    th {
        text-align: center;
        vertical-align: middle;
        justify-content: center;
        align-items: center;
        padding: 8px 16px;
        gap: 8px;
        left: 108px;
        top: 337px;
        background: ${({ background }) => (background ? `#fff` : `#e4e4e4`)};
    }
    td {
        justify-content: center;
        vertical-align: middle;
        align-items: center;
        background: #ffffff;
        border-width: 0px 1px 1px 1px;
        border-style: solid;
        border-color: #e4e4e4;
        font-size: 15px;
        color: #404040;
        font-weight: 400;
        font-size: 17px;
        line-height: 150%;
        padding-bottom: 18px;
        padding-top: 18px;
        text-align: center;
        border-style: solid;

        &.negative-value {
            color: #e5000c;
        }

        &.positive-value {
            color: #7ee543;
        }
    }
    &.no-border {
        tr,
        th,
        td {
            border: none;
        }
    }
    & > .text-align-right {
        tr,
        th,
        td {
            text-align: right;
        }
    }
`;

const TitleTable = styled.p`
    display: flex;
    align-items: center;
    color: #383838;
    font-size: 17px;
    line-height: 27px;
    margin-bottom: 0px;
    margin-top: 0px;
`;

export default {
    TablePrimary,
    TitleTable,
};
